<template>
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="clearfix mb-4">
          <div class="float-right">
            <div class="input-group input-group-sm">
              <b-button
                variant="primary"
                class="btn btn-label btn-primary"
                v-b-modal="'modal_addInvoice'"
                ><i class="bx bx-plus label-icon"></i>Add Invoice</b-button
              >
              <!-- Add Rate Modal -->
              <b-modal
                id="modal_addInvoice"
                title="Add Invoice"
                title-class="font-18"
                ok-title="Submit"
                size="md"
                value-type="MMM, DD, YY"
                @ok="submitAddInvoice"
                @cancel="clearEntry"
                @close="clearEntry"
              >
                <div class="mb-4">
                  <div class="form-group">
                    <label>Invoice Date</label>
                    <date-picker
                      v-model="addInvoiceData.date"
                      :first-day-of-week="1"
                      lang="en"
                      placeholder="Date..."
                      format="MMM DD, YY"
                      :class="{
                        'is-invalid': addInvoice_errors.dateError,
                      }"
                      :input-class="{
                        'form-control mx-input date-is-invalid':
                          addInvoice_errors.dateError,
                        'form-control mx-input': !addInvoice_errors.dateError,
                      }"
                    ></date-picker>
                  </div>
                </div>
                <div class="mt-4 mt-lg-0 mb-4">
                  <div class="form-group">
                    <label>Invoice Amount</label>
                    <b-form-input
                      v-model="addInvoiceData.amount"
                      type="number"
                      min="0"
                      max="100000000"
                      :state="validateNumber(addInvoiceData.amount)"
                    ></b-form-input>
                  </div>
                </div>
              </b-modal>
              <!-- /Add Rate Modal -->
              <!-- Edit Rate Modal -->
              <b-modal
                id="modal_editInvoice"
                title="Edit Invoice"
                title-class="font-18"
                ok-title="Submit"
                size="md"
                value-type="MMM, DD, YY"
                @ok="submitEditInvoice"
                @cancel="clearEntry"
                @close="clearEntry"
              >
                <div class="mb-4">
                  <div class="form-group">
                    <label>Invoice Date</label>
                    <date-picker
                      v-model="editInvoiceData.date"
                      :first-day-of-week="1"
                      lang="en"
                      placeholder="Date..."
                      format="MMM DD, YY"
                      :class="{
                        'is-invalid': editInvoice_errors.dateError,
                      }"
                      :input-class="{
                        'form-control mx-input date-is-invalid':
                          editInvoice_errors.dateError,
                        'form-control mx-input': !editInvoice_errors.dateError,
                      }"
                    ></date-picker>
                  </div>
                </div>
                <div class="mt-4 mt-lg-0 mb-4">
                  <div class="form-group">
                    <label>Invoice Amount</label>
                    <b-form-input
                      v-model="editInvoiceData.amount"
                      type="number"
                      min="0"
                      max="100000000"
                      :state="validateNumber(editInvoiceData.amount)"
                    ></b-form-input>
                  </div>
                </div>
              </b-modal>
              <!-- /Edit Rate Modal -->
            </div>
          </div>
          <h4 class="card-title mb-4">Invoice History</h4>
        </div>
        <div class="table-responsive mb-0">
          <b-table
            :items="invoices"
            :fields="fields"
            responsiv="xl"
            :per-page="invoicesPerPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-compare="tableSort"
            :filter="filter"
            :filter-included-fields="filterOn"
            style="text-align: center"
          >
            <template v-slot:cell(edit)="data">
              <div>
                <b-dropdown variant="primary" size="sm">
                  <template v-slot:button-content>
                    <i class="mdi mdi-chevron-down"></i>
                  </template>
                  <b-dropdown-item
                    v-b-modal.modal_editInvoice
                    @click="editInvoice(data.item.edit)"
                    ><i class="bx bx-edit-alt mr-2 tableIcons"></i
                    >Edit</b-dropdown-item
                  >
                  <b-dropdown-item @click="removeInvoice(data.item.edit)"
                    ><i class="bx bx-trash mr-2 tableIcons"></i
                    >Delete</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </template>
            <template v-slot:cell(amount)="data">
              ${{ data.item.amount }}
            </template>
          </b-table>
        </div>
        <div class="row mr-2">
          <div class="col-12">
            <div class="float-right mt-2 text-right">
              <p class="mb-2">
                Total Invoiced Amount: ${{ totalInvoicedAmount.toFixed(2) }}
              </p>
            </div>
          </div>
          <div class="col-12">
            <div class="float-right mt-2 text-right">
              <p class="mb-2">
                Total Job Revenue: ${{
                  totalRevenue != null ? totalRevenue.toFixed(2) : 0
                }}
              </p>
            </div>
          </div>
          <div class="col-12">
            <div class="float-right mt-2 text-right d-flex">
              <h5 class="mr-1">Remainder to Invoice:</h5>
              <h5
                v-bind:class="
                  (totalRevenue != null ? totalRevenue : 0) -
                    totalInvoicedAmount >=
                  1
                    ? 'text-success'
                    : 'text-failure'
                "
              >
                ${{
                  (
                    (totalRevenue != null ? totalRevenue : 0) -
                    totalInvoicedAmount
                  ).toFixed(2)
                }}
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import Swal from 'sweetalert2';
import { tableSort } from '../../helper/helpers.js';
import DatePicker from 'vue2-datepicker';
import moment from 'moment';

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      name: 'JobInvoiceTracking',
      selectedTab: 'employees',
      fields: [{ key: 'edit' }, { key: 'date' }, { key: 'amount' }],
      invoicesPerPage: 0,
      currentPage: 1,
      sortBy: 'date',
      sortDesc: true,
      filter: null,
      filterOn: [],
      addInvoiceData: {
        amount: null,
        date: null,
      },
      addInvoice_errors: {
        dateError: false,
        dateMessage: null,
        amountError: false,
        amountMessage: null,
      },
      editInvoiceData: {
        amount: null,
        date: null,
        index: null,
      },
      editInvoice_errors: {
        dateError: false,
        dateMessage: null,
        amountError: false,
        amountMessage: null,
      },
      totalInvoicedAmount: 0,
    };
  },
  props: {
    invoices: Array,
    jobNum: Number,
    jobID: null, //this is the doc id.
    totalExpenses: Number,
    totalRevenue: Number,
  },
  methods: {
    editInvoice: function(index) {
      let tempIndex = this.invoices.findIndex((o) => o.edit === index);
      //the edit button will send across the index, which we can populate the edit modal with that invoice's information.
      this.editInvoiceData.amount = this.invoices[tempIndex].amount;
      this.editInvoiceData.date = new Date(this.invoices[tempIndex].date);
      this.editInvoiceData.index = index;
    },
    submitEditInvoice: async function(bvModalEvt) {
      try {
        //if the submission does not pass the validation check, show error message and prevent modal from closing
        //else update database with new input
        if (
          this.validateDate(this.editInvoiceData.date) &&
          this.validateNumber(this.editInvoiceData.amount)
        ) {
          try {
            let db = firebase.firestore();
            let page = db.collection('jobs').doc(this.jobID);
            let tempIndex = -1;

            if (
              this.editInvoiceData.amount !== null &&
              this.editInvoiceData.date !== null &&
              this.editInvoiceData.index !== null
            ) {
              //find the index of the invoice.
              tempIndex = this.invoices.findIndex(
                (o) => o.edit === this.editInvoiceData.index
              );

              //update the local array, so we can udpate the database after. Remember that we need to splice to get the update of a specific index in an array to be reactive.
              this.invoices.splice(tempIndex, 1, {
                amount: this.editInvoiceData.amount,
                date: moment(this.editInvoiceData.date).format('MMM DD, YYYY'),
                edit: this.editInvoiceData.index,
              });

              //create a temp array and format the dates in a new Date() format, so we can udpate the database.
              let tempInvoices = this.invoices.map((o) => {
                return {
                  amount: o.amount,
                  date: new Date(o.date),
                };
              });

              await page
                .update({
                  invoices: tempInvoices,
                })
                .then(
                  Swal.fire(
                    'Success!',
                    'Invoice edited successfully.',
                    'success'
                  )
                )
                .catch(() => {
                  console.log(`Error editing invoice.`);
                  Swal.fire(
                    'Error!',
                    'An error was encountered when editing the invoice.',
                    'error'
                  );
                });
            }
          } catch (error) {
            console.log(error);
            Swal.fire(
              'Error!',
              'An error was encountered when editing the invoice.',
              'error'
            );
          }
          this.clearEntry();
        } else {
          this.submitErrorMessage = true;
          bvModalEvt.preventDefault();
        }
      } catch (err) {
        console.log(err);
      }
    },
    submitAddInvoice: async function(bvModalEvt) {
      try {
        //if the submission does not pass the validation check, show error message and prevent modal from closing
        //else update database with new input
        if (
          this.validateDate(this.addInvoiceData.date) &&
          this.validateNumber(this.addInvoiceData.amount)
        ) {
          try {
            let db = firebase.firestore();
            let page = db.collection('jobs').doc(this.jobID);

            if (
              this.addInvoiceData.amount !== null &&
              this.addInvoiceData.date !== null
            ) {
              //update the local array, so we can udpate the database after.
              this.invoices.push({
                amount: this.addInvoiceData.amount,
                date: moment(this.addInvoiceData.date).format('MMM DD, YYYY'),
                edit: (Math.random() + 1).toString(36).substring(7),
              });

              //create a temp array and format the dates in a new Date() format, so we can udpate the database.
              let tempInvoices = this.invoices.map((o) => {
                return {
                  amount: o.amount,
                  date: new Date(o.date),
                };
              });

              await page
                .update({
                  invoices: tempInvoices,
                })
                .then(() => {
                  Swal.fire(
                    'Success!',
                    'Invoice added successfully.',
                    'success'
                  );
                })
                .catch(() => {
                  console.log(`Error adding invoice.`);
                  Swal.fire(
                    'Error!',
                    'An error was encountered when adding the invoice.',
                    'error'
                  );
                });
            } else {
              console.log(`Fields are null`);
              Swal.fire(
                'Error!',
                'An error was encountered when adding the invoice. Some fields were null.',
                'error'
              );
            }
          } catch (error) {
            console.log(error);
            Swal.fire(
              'Error!',
              'An error was encountered when adding the invoice.',
              'error'
            );
          }
          this.clearEntry();
        } else {
          this.submitErrorMessage = true;
          bvModalEvt.preventDefault();
        }
      } catch (err) {
        console.log(err);
      }
    },
    removeInvoice: async function(index) {
      try {
        let db = firebase.firestore();
        let page = db.collection('jobs').doc(this.jobID);
        let tempIndex = -1;

        //find the index of the invoice.
        tempIndex = this.invoices.findIndex((o) => o.edit === index);
        if (tempIndex !== -1) {
          this.invoices.splice(tempIndex, 1);
        }

        //create a temp array so we can format the date and remove the edit field.
        let tempInvoices = this.invoices.map((o) => {
          return {
            amount: o.amount,
            date: new Date(o.date),
          };
        });

        await page
          .update({
            invoices: tempInvoices,
          })
          .then(() => {
            Swal.fire('Success!', 'Invoice deleted successfully.', 'success');
          })
          .catch(() => {
            console.log(`Error deleting invoice.`);
            Swal.fire(
              'Error!',
              'An error was encountered when deleting the invoice.',
              'error'
            );
          });
      } catch (err) {
        console.log(err);
        Swal.fire(
          'Error!',
          'An error was encountered when deleting the invoice.',
          'error'
        );
      }
    },
    validateDate(value) {
      if (value === null || value == '') {
        return false;
      } else {
        return true;
      }
    },
    validateNumber(value) {
      if (isNaN(Number(value)) || value === '') {
        return false;
      } else {
        return true;
      }
    },
    clearEntry() {
      this.addInvoiceData = {
        amount: null,
        date: null,
        index: null,
      };
      this.addInvoice_errors = {
        dateError: false,
        dateMessage: null,
        amountError: false,
        amountMessage: null,
      };
    },
    tableSort: tableSort,
  },
  watch: {
    invoices(data) {
      //watching the invoices array, so when it is populated, an item is added, edited, or deleted, we can update the total invoice amount.
      //loop the invoices and get a total invoiced amount.
      try {
        this.totalInvoicedAmount = 0; //reset the value when recalculating.
        if (data != null && data.length >= 1) {
          data.forEach((invoice) => {
            this.totalInvoicedAmount += !isNaN(Number(invoice.amount))
              ? Number(invoice.amount)
              : 0;
          });
        }
      } catch (err) {
        console.log(`Error getting total invoiced amount: ${err}`);
        Swal.fire(
          'Error!',
          'An error was encountered when calculating the total invoiced amount.',
          'error'
        );
      }
    },
  },
};
</script>
<style scoped>
.no-pointer {
  pointer-events: none;
}
.disabled-checkbox {
  cursor: not-allowed;
  opacity: 0.2;
  background-color: black !important;
}
.disabled-textbox {
  background: #e9e7e7;
}
</style>
